<template>
  <div class="item-panel-data">
    <div class="item-data-title">{{title}}:</div>
    <div class="item-data-value"><slot /></div>
  </div>
</template>

<style scoped>
.item-panel-data {
  -ms-flex-wrap: nowrap !important;
  flex-wrap: nowrap !important;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
  min-width: 300px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.item-data-title {
  font-weight: 600;
  margin: 0 1rem 0 0;
  color: #878a8c;
  width: 130px;
}
.item-data-value {
  flex: 1;
}
</style>

<script>
export default {
  name: 'ItemPanelData',
  props: {
    title: String
  }
}
</script>